// @ts-nocheck
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import {
  SYS_COLOR_FOREGROUND_INTERACTIVE_TERTIARY_100_DARK,
  SYS_SIZE_FIXED_200,
} from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import mapContext from '../../../contexts/map-context';
import { formatDistance, getDistanceFromLatLonPoints } from '../../../utils/distance';
import type { Dealer } from '../../../models/dealer';
import { messages } from '../../../i18n/messages';
import { SmallFiveStarRating } from '../../common/FiveStarRating/SmallFiveStarRating';

export interface Props {
  dealer: Dealer;
  isSelected: boolean;
  isMapMarkerHovered: boolean;
}

export interface SearchResultsEntryContainerProps {
  isSelected: boolean;
  isMapMarkerHovered: boolean;
  isLegacy?: boolean;
}

const SearchResultsEntry = ({ dealer, isSelected, isMapMarkerHovered }: Props) => {
  const { userGeolocation, distanceUnit, dealerRatings } = mapContext.useMapState();
  const salesOption = useI18n(messages.filter_sales);
  const serviceOption = useI18n(messages.filter_service);
  const services = dealer.services
    .filter((service) => service === salesOption || service === serviceOption)
    .join(', ');

  const distanceForSearchByTerm = React.useMemo(() => {
    if (userGeolocation) {
      return formatDistance(
        getDistanceFromLatLonPoints(
          userGeolocation.lat,
          userGeolocation.lng,
          dealer.latitude,
          dealer.longitude,
        ),
        distanceUnit,
      );
    }
    return null;
  }, [userGeolocation?.lat, userGeolocation?.lng]);

  return (
    <SearchResultsEntryContainer
      isSelected={isSelected}
      isMapMarkerHovered={isMapMarkerHovered}
      data-test-id="search-results-entry"
      isLegacy={process.env.IS_LEGACY}
    >
      <DealerCardSection>
        <DealerCardName role="button" data-test-id="dealer-name-container">
          <Text
            tag="p"
            variant={{ order: '1', style: 'normal', type: 'copy' }}
            data-test-id="dealer-name"
          >
            {dealer?.additionalData?.displayName
              ? dealer?.additionalData?.displayName
              : dealer.name}
          </Text>
        </DealerCardName>
        <DealerCardDistance data-test-id="dealer-distance">
          <Text tag="p" variant={{ order: '1', style: 'normal', type: 'copy' }}>
            {dealer?.distance !== null
              ? formatDistance(dealer?.distance, distanceUnit)
              : distanceForSearchByTerm}
          </Text>
        </DealerCardDistance>
      </DealerCardSection>
      {dealerRatings?.[dealer.dealerId] >= 0 && (
        <SmallFiveStarRating rating={dealerRatings?.[dealer.dealerId]} isValueDisplayed />
      )}
      <DealerAddress
        forwardedAs="span"
        variant={{ order: '2', style: 'normal', type: 'copy' }}
        data-test-id="dealer-address"
        isLegacy={process.env.IS_LEGACY}
      >
        {dealer.address.join(', ')}
      </DealerAddress>

      {!!dealer.additionalData?.locationName && (
        <DealerCardLocation>
          <Text
            tag="p"
            variant={{ order: '1', style: 'normal', type: 'copy' }}
            data-test-id="dealer-location"
          >
            {dealer.additionalData.locationName}
          </Text>
        </DealerCardLocation>
      )}

      <DealerCardServices>
        <Text tag="p" variant={{ order: '1', style: 'normal', type: 'copy' }}>
          {services}
        </Text>
      </DealerCardServices>
      {/* {departmentCurrentDayOpeningHours && (
        <DealerCardOpeningHoursContainer data-test-id="dealer-opening-hours">
          {departmentCurrentDayOpeningHours.map((department) => (
            <MemoizedOpeningHours
              key={department.id}
              {...department}
              data-test-id="dept-opening-hours"
            />
          ))}
        </DealerCardOpeningHoursContainer>
      )} */}
    </SearchResultsEntryContainer>
  );
};

const hoverItem = process.env.IS_LEGACY
  ? `
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
`
  : `border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;`;

const SearchResultsEntryContainer = styled.div<SearchResultsEntryContainerProps>`
  border-top: ${(props) => (props.isLegacy ? '1px solid #d9d9d9' : '1px solid #3F4247')};
  padding: ${SYS_SIZE_FIXED_200} 0;
  display: grid;
  &:hover {
    ${hoverItem}
  }
  ${(props) => props.isMapMarkerHovered && hoverItem}
`;

const DealerCardSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const DealerCardName = styled.div<{ isLegacy?: boolean }>`
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
  flex: 8;
  p {
    color: ${(props) =>
      props.isLegacy ? '#000' : SYS_COLOR_FOREGROUND_INTERACTIVE_TERTIARY_100_DARK};
  }
`;

const DealerAddress = styled(Text)<{ isLegacy?: boolean }>`
  color: ${(props) => (props.isLegacy ? '#666666' : '#9FA1A3')};
`;
const DealerCardLocation = styled.div``;
const DealerCardDistance = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DealerCardServices = styled.div`
  text-transform: capitalize;
`;
export const DealerCardOpeningHoursContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export default React.memo(SearchResultsEntry);
